import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';
import { DialogTitle, FormControl } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import useGetEditUserInfo from 'api/users/useGetEditUserInfo/useGetEditUserInfo';
import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';

const defaultValues = {
  mobile: '',
  name: '',
  family: '',
};

const UserEditModal = ({
  open,
  handleClose,
  editLoading,
  onEdit,
  initialValues,
}) => {
  const [getUserEditInfo, userInfoLoading, editUserInfo] = useGetEditUserInfo();
  const {
    handleSubmit,
    reset,
    control,
    formState: { errors, isSubmitted },
  } = useForm({ defaultValues });

  useEffect(() => {
    if (open && initialValues?.id) {
      getUserEditInfo(initialValues.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, initialValues?.id]);

  useEffect(() => {
    if (open) {
      reset({
        mobile: editUserInfo?.mobile ?? '',
        name: editUserInfo?.name ?? '',
        family: editUserInfo?.family ?? '',
      });
    }
  }, [open, editUserInfo, reset]);

  const onSubmit = data => {
    onEdit({
      mobile: data.mobile,
      name: data.name,
      family: data.family,
    });
  };

  return (
    <Dialog open={open} onClose={handleClose} sx={{ direction: 'rtl' }}>
      <DialogTitle>ویرایش کاربر</DialogTitle>

      <DialogContent>
        <FormFieldWrapper>
          <FormControl variant="standard" sx={{ m: 2, minWidth: 300 }}>
            <Controller
              name="mobile"
              control={control}
              rules={{
                required: 'موبایل الزامی است',
                pattern: {
                  value: /^09\d{9}$/,
                  message: 'لطفا شماره موبایل صحیح وارد کنید',
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  autoFocus
                  label="موبایل"
                  variant="standard"
                  sx={{ minWidth: 300 }}
                  inputProps={{
                    dir: 'ltr',
                    inputMode: 'numeric',
                    maxLength: 11,
                  }}
                  placeholder="09xxxxxxxxx"
                  InputLabelProps={{ shrink: !!field.value }}
                  error={isSubmitted ? !!errors.mobile : null}
                  helperText={errors.mobile?.message}
                />
              )}
            />
          </FormControl>
        </FormFieldWrapper>

        <FormFieldWrapper>
          <FormControl variant="standard" sx={{ m: 2, minWidth: 300 }}>
            <Controller
              name="name"
              control={control}
              rules={{ required: 'نام الزامی است' }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="نام"
                  variant="standard"
                  sx={{ minWidth: 300 }}
                  InputLabelProps={{ shrink: !!field.value }}
                  error={isSubmitted ? !!errors.name : null}
                  helperText={isSubmitted ? errors.name?.message : null}
                />
              )}
            />
          </FormControl>
        </FormFieldWrapper>

        <FormFieldWrapper>
          <FormControl variant="standard" sx={{ m: 2, minWidth: 300 }}>
            <Controller
              name="family"
              control={control}
              rules={{ required: 'نام خانوادگی الزامی است' }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="نام خانوادگی"
                  variant="standard"
                  sx={{ minWidth: 300 }}
                  InputLabelProps={{ shrink: !!field.value }}
                  error={isSubmitted ? !!errors.family : null}
                  helperText={errors.family?.message}
                />
              )}
            />
          </FormControl>
        </FormFieldWrapper>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          disabled={editLoading || userInfoLoading}
        >
          انصراف
        </Button>
        <LoadingButton
          variant="contained"
          onClick={handleSubmit(onSubmit)}
          loading={editLoading || userInfoLoading}
          color="warning"
        >
          ویرایش
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default UserEditModal;

const FormFieldWrapper = styled.div`
  margin: 20px 8px 0;
  min-width: 300px;
`;
